<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      UnApproved Travel Sheet</h5>
  </div>
<div id="mainContent" class="container">
  <div class="">
    <div class="row pt-3">
      <div class="col-md-12">
        <table class="table table-sm table-bordered table-striped">
          <thead class="">
            <tr>
              <th>Status</th>
              <th>Employee Name</th>
              <th>Approver Name</th>
              <th>Entry Date</th>
              <th>Client</th>
              <th>Assignment</th>
              <th>Financial Year</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Total</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody *ngFor="let travelsheet of travelSheetList">
            <tr>
              <td *ngIf="travelsheet.sheetStatus=='Submitted'">{{ travelsheet.sheetStatus }}</td>
              <td *ngIf="travelsheet.sheetStatus=='Resent'">
                <a
                style="color: #800000; cursor: pointer;text-decoration: underline;"
                (click)="openModal(resendModalContent, travelsheet)" >
                Resent Reason
              </a>
              </td>
              <td>
                {{ travelsheet.user.firstName }}
                {{ travelsheet.user.middleName }}
                {{ travelsheet.user.lastName }}
              </td>
              <td>
                {{ travelsheet.approver.firstName }}
                {{ travelsheet.approver.middleName }}
                {{ travelsheet.approver.lastName }}
              </td>
              <td>
                {{ travelsheet.entryDate | date: "dd-MMMM-yyyy" }}
              </td>
              <td>{{ travelsheet.client.name }}</td>
              <td>{{ travelsheet.assignment.name }}</td>
              <td>{{ travelsheet.fy.name }}</td>
              <td>
                {{ travelsheet.fromDate | date: "dd-MMMM-yyyy" }}
              </td>
              <td>
                {{ travelsheet.toDate | date: "dd-MMMM-yyyy" }}
              </td>
              <td>{{ travelsheet.totalAmount }}</td>
              <td>{{ travelsheet.remark }}</td> 
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</div>

<ng-template #resendModalContent let-modal>
  <div class="modal-body">
    <div class="row col-sm-12">
        <label>Resent Reason :</label>
    </div>
    <div class="row col-sm-12">
      <span>{{resendReason}}</span>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <!-- <button
          id="closeStandardBtn"
          name="closeStandardBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="resendTravelSheet()"
        >
          ok
        </button> -->
      </div>
      <div class="col-sm-3">
        <button
          id="closeStandardBtn"
          name="closeStandardBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="modal.dismiss('Cross click')"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
